var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"creative-checkbox-container",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{class:{
      'creative-checkbox' : true,
      'creative-checkbox-checked': _vm.value,
    }}),_c('p',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }